import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";
const TransferReceiptList = (props) => {
  const [loading, setLoading] = useState(false);

  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteHolidays } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete these detail?",
      onOk() {
         
        var goodsTransferReceiptId=data.goodsTransferReceiptId
        deleteHolidays(
          {
            url: `/api/transferReceipt/?orgId=${localStorage.getItem("orgId")}&goodsTransferReceiptId=${goodsTransferReceiptId}&deletedById=${localStorage.getItem(
              "empId")}`,
            method: "DELETE",

              
          },
          (data) => {
            toast.success("Data deleted successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/transferReceipt/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.goodsTrasnferNo?.includes(filetrtext) ||
        item?.employeeName?.includes(filetrtext) ||
        item?.vmeNo?.includes(filetrtext) ||
        item?.driverName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    // //console.log(data);

    const Id = data && data.goodsTransferReceiptId;

    getDetailView(
      {
        url: `/api/transferReceipt/?orgId=${localStorage.getItem(
          "orgId"
        )}&goodsTransferReceiptId=${Id}`,
      },
      (res) => {
        //console.log("Detail View", res);
        setSelectedData(res);
      }
    );

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    setLoading(true);
    // console.log(approvalStatus);
    let data = "";
    if (approvalStatus === "approve") {
      data = {
        itemId:
          selectedApprovalData && selectedApprovalData.goodsTransferReceiptId,
        approved: 1,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "disapprove") {
      data = {
        itemId:
          selectedApprovalData && selectedApprovalData.goodsTransferReceiptId,
        approved: 2,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    } else if (approvalStatus === "sendNextApprove") {
      data = {
        itemId:
          selectedApprovalData && selectedApprovalData.goodsTransferReceiptId,
        approved: 0,
        approvedBy: parseInt(localStorage.getItem("id")),
        serviceId: serviceId,
        nextlevel: 1,
        orgId: localStorage.getItem("orgId"),
        reamrk: remark,
      };
    }

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/approveTransferReceipt/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <h4 className="card-title">Transfer Receipt Detail</h4>
        <div className="card-tools text-right">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={() => setIsModalOpen(false)}
          >
            <i className="fas fa-times" />
          </button>
          <hr />
        </div>
        {selectedData && (
          <div>
            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> Date</label>
              </div>
              <div className="col-md-1">
                <label> : </label>{" "}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.goodsTransferReceiptDate} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> Field Officer </label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.employeeName} </label>{" "}
              </div>
            </div>

            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> Doc No </label>
              </div>
              <div className="col-md-1">
                <label> : </label>{" "}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.goodsTrasnferNo} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> TimeStamp</label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.timeStamp} </label>{" "}
              </div>
            </div>

            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> Warehouse </label>
              </div>
              <div className="col-md-1">
                <label> : </label>
                {""}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.warehouseName} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> Received From Warehouse</label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.receivedFromWarehouseName} </label>{" "}
              </div>
            </div>

            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> Goods Trasnfer No </label>
              </div>
              <div className="col-md-1">
                <label> : </label>
                {""}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.goodsTrasnferNo} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> Vehicle</label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.vmeModelName} </label>{" "}
              </div>
            </div>

            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> Driver Name </label>
              </div>
              <div className="col-md-1">
                <label> : </label>{" "}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.driverName} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> Driver Contact No </label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.driverContactNo} </label>{" "}
              </div>
            </div>

            <div className="row">
              <div className="col-md-2">
                {" "}
                <label> End Meter Reading </label>
              </div>
              <div className="col-md-1">
                <label> : </label>{" "}
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.endMeterReading} </label>{" "}
              </div>
              <div className="col-md-2">
                <label> Remark/Note </label>{" "}
              </div>
              <div className="col-md-1">
                {" "}
                <label> : </label>
              </div>
              <div className="col-md-3">
                {" "}
                <label> {selectedData.remark} </label>{" "}
              </div>
            </div>
            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Product Type</th>
                    <th>Product Subtype</th>
                    <th>Product Name</th>
                    <th>Quantity</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.productData &&
                    selectedData.productData.map((itm, i) => {
                      return (
                        <tr key={i} className="cursor-pointer">
                          <td>{i + 1}</td>
                          <td>{itm.productTypeName}</td>
                          <td>{itm.productSubTypeName}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unitAbbreviation}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>

      <div className="content-wrapper">
        <div className="row mx-1">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Transfer Receipt Detail
            </label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  sId(serviceId);
                  addForm(true);
                  props.update(false);
                }}
              >
                Add Transfer Receipt Detail
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th> Date</th>
                            <th>Doc No</th>
                            <th>Received By</th>
                            <th>Warehosue</th>
                            <th>Received From Warehosue</th>
                            <th>Goods Trasnfer No</th>
                            <th>Vehicle </th>
                            {/* <th>Driver Name </th> */}

                            <th>Approval</th>
                            <th>Approved by</th>
                            {canDelete === "block" && <th>Delete</th>}
                            {canView === "block" && <th>View</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.goodsTransferReceiptDate}</td>

                                <td>{x.goodsTrasnferReceiptNo}</td>
                                <td>{x.employeeName}</td>
                                <td>{x.warehouseName}</td>
                                <td>{x.receivedFromWarehouseName}</td>

                                <td>{x.goodsTrasnferNo}</td>
                                <td>{x.vmeNo}</td>

                                {/* <td>{x.driverName}</td> */}

                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    disabled={
                                      x.nextlevel == 1
                                        ? x.allowApproveUserId == loginUserId
                                          ? false
                                          : true
                                        : x.approved == 0 &&
                                          x.reportingId == loginUserId
                                        ? false
                                        : true
                                    }
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>

                                <td>{x.approvedByName}</td>
                                {canDelete === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={(e) => deleteOperation(e, x)}

                                      disabled={

                                        x.status == 1 && x.approved == 0 ? false : true
                                        
                                           
                                      }
                                    >
                                      {" "}
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </td>
                                )}
                                {canView === "block" && (
                                  <td>
                                     
                                    <button
                                      className="btn"
                                      onClick={() => openModal(x)}
 
                                      
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Warehouse Goods Transfer Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("approve");
            }}
            disabled={loading}
          >
            {loading ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => {
              handleApprovalSubmit("disapprove");
            }}
            className="btn btn-sm btn-primary"
            disabled={loading}
          >
            {loading ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              handleApprovalSubmit("sendNextApprove");
            }}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default TransferReceiptList;
